

















































import { Vue, Component, Prop } from 'vue-property-decorator'
import Chatrs1 from '@/components/g2Charts/charts'
import Drawer from './drawer.vue'
import { TableRowInfoList, ChartInfo } from '@/types/tenant/dataPage'
import { DrawerCom } from '../index'
import { tooltipLthFn } from '../utils'
@Component({
  components: {
    Drawer,
    Chatrs1
  }
})
export default class CardCharts extends Vue {
  @Prop() card!: TableRowInfoList;
  status = false;
  sketchList: string[] = [];
  chartInfo: ChartInfo[] = [];
  mounted () {
    this.status =
      (document.querySelector('#cardChart') as HTMLDivElement)?.clientWidth >=
      700
    const { values, ratioValues, valueUnit } = this.card
    const _lastList: Function = this.lastList
    if (values && ratioValues) {
      const list0 =
        _lastList(values, 1).value === 0
          ? 0
          : _lastList(values, 2).value === 0
            ? 0
            : (
              (_lastList(values, 1).value / _lastList(values, 2).value - 1) *
              100
            ).toFixed(2)
      this.chartInfo.push(
        {
          name: '较上期(%)',
          positiveNumber: +list0 > 0,
          count: list0
        },
        {
          name: '同比增长(%)',
          positiveNumber: _lastList(ratioValues, 1).value > 0,
          count: _lastList(ratioValues, 1).value
        },
        {
          name: '最新数据',
          positiveNumber: _lastList(values, 1).value > 0,
          count: _lastList(values, 1).value + '  ' + valueUnit
        }
      )
    } else if (values) {
      const list0 =
        _lastList(values, 1).value === 0
          ? 0
          : _lastList(values, 2).value === 0
            ? 0
            : (
              (_lastList(values, 1).value / _lastList(values, 2).value - 1) *
              100
            ).toFixed(2)
      this.chartInfo.push(
        {
          name: '较上期(%)',
          positiveNumber: +list0 > 0,
          count: list0
        },
        {
          name: '同比增长(%)',
          count: '-'
        },
        {
          name: '最新数据',
          positiveNumber: +_lastList(values, 1).value > 0,
          count: _lastList(values, 1).value + '  ' + valueUnit
        }
      )
    } else if (ratioValues) {
      this.chartInfo.push(
        {
          name: '较上期(%)',
          count: '-'
        },
        {
          name: '同比增长(%)',
          positiveNumber: +_lastList(ratioValues, 1).value > 0,
          count: _lastList(ratioValues, 1).value
        },
        {
          name: '最新数据',
          count: '-'
        }
      )
    }
    if (this.card.sketch) {
      this.sketchList = tooltipLthFn(this.card.introductions || '')
    }
  }

  private lastList (data: { value: string; date: string }[], idx: number) {
    return data[data.length - idx]
  }

  private handleClickDrawer () {
    (this.$refs.drawerRef as DrawerCom).show(this.card)
  }
}
